import email from "../assets/email.png";
import mobile from "../assets/mobile.png";

export default { email, mobile };
